import { render, staticRenderFns } from "./pt.vue?vue&type=template&id=50aaa382&scoped=true&"
import script from "./pt.vue?vue&type=script&lang=js&"
export * from "./pt.vue?vue&type=script&lang=js&"
import style0 from "./pt.vue?vue&type=style&index=0&id=50aaa382&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50aaa382",
  null
  
)

export default component.exports